import { render, staticRenderFns } from "./LottieSelectMailbox.vue?vue&type=template&id=74f2d841&scoped=true&"
import script from "./LottieSelectMailbox.vue?vue&type=script&lang=js&"
export * from "./LottieSelectMailbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f2d841",
  null
  
)

export default component.exports